import { ButtonApiErrorWrapper } from 'app/components/shared/ButtonApiErrorWrapper'
import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { Button } from 'app/components/ui/Button'
import { Form } from 'app/components/ui/Form'
import { useUpdateUserEmail } from 'app/queries/user'
import React from 'react'
import styled from 'styled-components'

import {
  adaptUpdateUserEmailFormDataToAPI,
  updateUserEmailDefaultValues,
  UpdateUserEmailFormData,
  updateUserEmailValidationSchema,
} from './form'

type Props = { onSuccess?: () => void }

export const UpdateUserEmailForm = ({ onSuccess }: Props): JSX.Element => {
  const {
    mutate: executeUpdateUserEmail,
    isLoading,
    isError,
    error,
  } = useUpdateUserEmail()

  const onSubmit = (data: UpdateUserEmailFormData) =>
    executeUpdateUserEmail(adaptUpdateUserEmailFormDataToAPI(data), {
      onSuccess: () => {
        if (onSuccess) onSuccess()
      },
    })

  return (
    <Form<UpdateUserEmailFormData>
      defaultValues={updateUserEmailDefaultValues}
      validationSchema={updateUserEmailValidationSchema}
      onSubmit={onSubmit}
    >
      <>
        <EmailFormGroup>
          <SmartInput
            label='Email'
            type='email'
            name='email'
            placeholder='Inserisci la tua mail'
            labelRequired
          />
        </EmailFormGroup>
        <ButtonApiErrorWrapper isError={isError} error={error} alignCenter>
          <Button size='lg' type='submit' disabled={isLoading}>
            {isLoading ? 'Caricamento...' : 'Conferma'}
          </Button>
        </ButtonApiErrorWrapper>
      </>
    </Form>
  )
}

const EmailFormGroup = styled(FormGroup)`
  margin-bottom: 3rem;
`
